var _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlocksIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 110,
    viewBox: "0 0 220 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: 67.5366,
    width: 16.7317,
    height: 6,
    fill: "#CF955B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 39,
    width: 25.7317,
    height: 6,
    fill: "#E3B4B1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 202,
    width: 18,
    height: 6,
    fill: "#E3B4B1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 104,
    width: 16.7317,
    height: 6,
    fill: "#A5D4CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocksIcn);
export default __webpack_public_path__ + "static/media/blocks-icn.9736e24b4d3615bfff67edbb390c18cb.svg";
export { ForwardRef as ReactComponent };